module.exports = __webpack_public_path__ + "media/navExample.0bd0f2e9.mp4";